import { Flex, Image } from '@pega/cosmos-react-core';

interface ImageBlockProps {
  src: string;
  alt: string;
}

const ImageBlock = ({ src, alt }: ImageBlockProps) => {
  return (
    <Flex container={{ alignItems: 'end' }}>
      <Image src={src} alt={alt} />
    </Flex>
  );
};

export default ImageBlock;
